<div class="form-group" *ngIf="displaySearch">
  <label class="control-label" [innerText]="searchTitle"></label>
  <tablesready-search-bar
    [whiteIconColorEnabled]="true"
    [placeholder]="searchPlaceholder"
    (search)="filterItems($event)"
  ></tablesready-search-bar>
</div>

<div class="checkbox-list" [ngStyle]="contentStyle">
  <ul class="list-group">
    <li class="list-group-item d-flex flex-row justify-content-between" *ngIf="selectAll && showSelectAll">
      <span [innerText]="selectAllTitle"></span>
      <input
        type="checkbox"
        #selectAllCheckbox
        [disabled]="disabled"
        (change)="toggleAll(selectAllCheckbox.checked)"
        [checked]="allItemsSelected"
      />
    </li>
    <li class="list-group-item d-flex flex-row justify-content-between" *ngFor="let item of itemsToDisplay">
      <div class="d-flex flex-row align-items-center">
        <span class="mr-1" [innerText]="item.name"></span>
        <info-badge *ngIf="item.label" [label]="item.label | uppercase"></info-badge>
      </div>
      <input
        #locationCheckbox
        type="checkbox"
        [value]="item.value"
        [disabled]="disabled"
        (change)="change(locationCheckbox.checked, locationCheckbox.value)"
        [checked]="itemSelected(item.value)"
      />
    </li>
  </ul>
</div>
